import * as React from "react";
import { WithNamespaces, withNamespaces } from "react-i18next";

import {
  Proposal,
  GenericalResponse,
  PayloadPlanDecoration,
  ResponsePlanDecoration
} from "src/redux/projects";
import ControlBar, { ControlBarEvents } from "./ControlBar";
import fscreen from "fscreen";
import { ImagePanWithPin } from "./ImagePanWithPin";
import PlanDecorationSidebar from "./PlanDecorationSidebar";
import { Print, NoPrint } from "react-easy-print";
import { downloadUrl } from "src/helpers/downloadUrl";
import { CurrentResponse } from "src/redux/currentResponses";
import { Profil } from "src/redux/user";
import { shareProposalWithModal } from "src/helpers/shareProposalWithModal";

interface Props {
  proposal: Proposal;
  response: CurrentResponse | undefined;
  handleSubmitProposalPending: (
    payload: PayloadPlanDecoration,
    response: ResponsePlanDecoration | undefined
  ) => void;
  handleSubmitProposalValidated: (
    payload: PayloadPlanDecoration,
    currentReponse: GenericalResponse | undefined
  ) => void;
  handleChangeRessourcePlanDecoration: (
    ressourceId: number,
    response: GenericalResponse
  ) => void;
  isLocked: boolean;
  loader: boolean;
  profil: Profil;
}
interface State {
  // image zoom
  imageZoom: number;
  currentId: number;
  step: number;
}
type PropsWithNamespaces = Props & WithNamespaces;
class PlanDecoration extends React.Component<PropsWithNamespaces, State> {
  fullscreenDiv = React.createRef<any>();

  state = {
    step: 0,
    imageZoom: 1.15,
    currentId: this.props.proposal.responses
      ? this.props.proposal.responses[0].ressourceId
      : 0
  };
  controlBarHandler = (type: ControlBarEvents, data: any) => {
    switch (type) {
      case ControlBarEvents.ToggleFullScreen:
        this.setState({ imageZoom: 1 }, () => this.toggleFullScreen());
        break;
      case ControlBarEvents.Print:
        window.print();
        break;
      case ControlBarEvents.Download:
        downloadUrl(
          this.props.proposal.ressources[this.state.currentId].image,
          this.props.proposal.ressources[this.state.currentId].label
        );
        break;
      case ControlBarEvents.Share:
        shareProposalWithModal(this.props.proposal);
        break;
      case ControlBarEvents.ZoomIn:
        this.setState({ imageZoom: Math.max(this.state.imageZoom + 0.2, 0) });
        break;
      case ControlBarEvents.ZoomOut:
        this.setState({ imageZoom: Math.max(this.state.imageZoom - 0.2, 0) });
        break;
    }
  };

  /**
   * Toggle full screen for image element
   */
  toggleFullScreen() {
    if (fscreen.fullscreenElement === null) {
      fscreen.requestFullscreen(this.fullscreenDiv.current);
    } else {
      fscreen.exitFullscreen();
    }
  }

  /**
   * Once image has loaded, we calculate first zoom so the whole image fits in pan div
   */
  onImageLoaded = (image: HTMLImageElement) => {
    const fittingZoom =
      this.fullscreenDiv.current.offsetHeight / image.offsetHeight;
    this.setState({ imageZoom: fittingZoom + 0.15 });
  };

  handleChangeArtwork = ressourceId => {
    if (this.props.response) {
      this.props.handleChangeRessourcePlanDecoration(
        ressourceId,
        this.props.response.response
      );
    }
    this.setState({
      currentId: ressourceId
    });
  };

  onChangeStep = (value: number) => {
    this.setState({
      step: value
    });
  };

  render() {
    return (
      <div className={`proposal deco ${this.state.step > 0 ? "expanded" : ""}`}>
        <div className="d-flex">
          <div className="proposal-screen">
            <div ref={this.fullscreenDiv}>
              <NoPrint force={true}>
                <ImagePanWithPin
                  comments={[]}
                  url={
                    this.props.proposal.ressources[this.state.currentId].image
                  }
                  zoom={this.state.imageZoom}
                  onImageLoad={this.onImageLoaded}
                  locked={this.props.isLocked}
                />
              </NoPrint>
              <Print name="deco" printOnly={true}>
                <img
                  width="1080px"
                  src={
                    this.props.proposal.ressources[this.state.currentId].image
                  }
                />
              </Print>
            </div>
            <div className="flex-1 d-flex align-items-center justify-content-center">
              <ControlBar
                onEvent={this.controlBarHandler}
                buttons={["fscreen", "zoom", "download", "print", "share"]}
              />
            </div>
          </div>
          <NoPrint force={true}>
            <PlanDecorationSidebar
              response={this.props.response}
              proposal={this.props.proposal}
              isLocked={this.props.isLocked}
              handleChangeArtwork={this.handleChangeArtwork}
              currentId={this.state.currentId}
              handleSubmitProposalPending={
                this.props.handleSubmitProposalPending
              }
              handleSubmitProposalValidated={
                this.props.handleSubmitProposalValidated
              }
              loader={this.props.loader}
              step={this.state.step}
              onChangeStep={this.onChangeStep}
              handleChangeRessourcePlanDecoration={
                this.props.handleChangeRessourcePlanDecoration
              }
            />
          </NoPrint>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(PlanDecoration);



// WEBPACK FOOTER //
// ./src/components/PlanDecoration.tsx